import { appGetState } from 'legacy/lut/store'

import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'

import { ISPJBPResponse } from './models/ISPJBPResponse'

export const fetchPartners = async <T>(partnerIds: string[]): Promise<ISPJBPResponse<T>> => {
  const url = proxy(`/webservice/197/sp/v3/spJBPPartnerInfoByCustomFilter/call`)

  const payload = { 'p.Filter': JSON.stringify(partnerIds) }

  const { app } = appGetState()
  const [accessToken] = await getTokens(app.ownerId)
  const headers = new HttpHeaders()
  if (accessToken) {
    headers.add('Authorization', `Bearer ${accessToken}`)
  }

  const response = await Rest.post({ url, payload, headers })

  const total = response?.Total || 0
  const rows = response?.Rows || []
  const partners = rows.length ? JSON.parse(rows[0].Result || '') : []

  return { Total: total, Rows: partners }
}
